import React from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import AddButton from "../../../../../../ui/AddButton";
import NoData from "./NoData";
import ProgramDialog from "./ProgramDialog";
import PlanExpandPanel from "./PlanExpandPanel";
import {
  addModuleVolumeAction,
  addModuleThemeVolumeAction,
  updateModuleVolumeAction,
  deleteModuleVolumeAction,
  deleteModuleThemeVolumeAction,
  updateModuleThemeVolumeAction,
  addModuleLessonAction,
  deleteModuleLessonAction,
  updateModuleLessonAction
} from "../../../../store/actions";

const useStyles = makeStyles({
  addTitle: {
    display: "flex",
    alignItems: "center",
    "& > span": {
      fontSize: "14px",
      lineHeight: "18px",
      marginRight: 20
    }
  }
});

const ThematicPlan = ({
  title,
  allModuleVolume,
  addModuleVolume,
  updateModuleVolume,
  deleteModuleVolume,
  allModuleThemeVolume,
  allModuleAbilityTheme,
  addModuleThemeVolume,
  deleteModuleThemeVolume,
  moduleAbility,
  updateModuleTheme,
  allLessonType,
  addModuleLesson,
  allModuleLessonTheme,
  deleteModuleLesson,
  updateModuleLesson,
  initialVolume = {
    number: "",
    name: ""
  }
}) => {
  const { addTitle } = useStyles();
  const [showProgramDialog, setShowProgramDialog] = React.useState(false);
  const [showProgramEditDialog, setShowProgramEditDialog] = React.useState(
    false
  );
  const [showThemeDialog, setShowThemeDialog] = React.useState(false);
  const [showThemeEditDialog, setShowThemeEditDialog] = React.useState(false);
  const [volume, setVolume] = React.useState(initialVolume);

  const changeVolume = event => {
    setVolume({
      ...volume,
      [event.target.name]: event.target.value
    });
  };

  const openProgramDialog = () => {
    setShowProgramDialog(true);
  };

  const closeProgramDialog = () => {
    setShowProgramDialog(false);
  };

  const openProgramEditDialog = () => {
    setShowProgramEditDialog(true);
  };

  const closeProgramEditDialog = () => {
    setShowProgramEditDialog(false);
  };

  const openThemeDialog = () => {
    setShowThemeDialog(true);
  };

  const closeThemeDialog = () => {
    setShowThemeDialog(false);
  };

  const openThemeEditDialog = () => {
    setShowThemeEditDialog(true);
  };

  const closeThemeEditDialog = () => {
    setShowThemeEditDialog(false);
  };

  return (
    <>
      <div className={addTitle}>
        <span>{title}</span>
        <AddButton
          onClick={() => openProgramDialog(true) || setVolume(initialVolume)}
        />
      </div>
      {allModuleVolume.length === 0 && (
        <NoData
          title="Учебный план еще не заполнен"
          desc="Добавьте раздел, темы и занятия"
        />
      )}
      <ProgramDialog
        type="add"
        title="Добавить раздел"
        showProgramDialog={showProgramDialog}
        closeProgramDialog={closeProgramDialog}
        addModuleVolume={addModuleVolume}
        volume={volume}
        changeVolume={changeVolume}
      />
      <PlanExpandPanel
        showProgramDialog={showProgramEditDialog}
        allModuleVolume={allModuleVolume}
        updateModuleVolume={updateModuleVolume}
        updateModuleTheme={updateModuleTheme}
        openProgramDialog={openProgramEditDialog}
        closeProgramDialog={closeProgramEditDialog}
        deleteModuleVolume={deleteModuleVolume}
        allModuleThemeVolume={allModuleThemeVolume}
        allModuleAbilityTheme={allModuleAbilityTheme}
        allModuleLessonTheme={allModuleLessonTheme}
        showThemeDialog={showThemeDialog}
        openThemeDialog={openThemeDialog}
        closeThemeDialog={closeThemeDialog}
        showThemeEditDialog={showThemeEditDialog}
        openThemeEditDialog={openThemeEditDialog}
        closeThemeEditDialog={closeThemeEditDialog}
        moduleAbility={moduleAbility}
        addModuleThemeVolume={addModuleThemeVolume}
        deleteModuleThemeVolume={deleteModuleThemeVolume}
        deleteModuleLesson={deleteModuleLesson}
        allLessonType={allLessonType}
        addModuleLesson={addModuleLesson}
        updateModuleLesson={updateModuleLesson}
      />
    </>
  );
};

const mapStateToProps = state => ({
  moduleVolume: state.modules.moduleVolume,
  allModuleVolume: state.modules.allModuleVolume,
  moduleAbility: state.modules.moduleAbility,
  moduleLesson: state.modules.moduleLesson
});

const mapDispatchToProps = dispatch => ({
  addModuleVolume: value => dispatch(addModuleVolumeAction(value)),
  updateModuleVolume: (volumeId, data) =>
    dispatch(updateModuleVolumeAction(volumeId, data)),
  deleteModuleVolume: value => dispatch(deleteModuleVolumeAction(value)),
  addModuleThemeVolume: theme => dispatch(addModuleThemeVolumeAction(theme)),
  updateModuleTheme: (themeId, data) =>
    dispatch(updateModuleThemeVolumeAction(themeId, data)),
  deleteModuleThemeVolume: theme =>
    dispatch(deleteModuleThemeVolumeAction(theme)),
  addModuleLesson: lesson => dispatch(addModuleLessonAction(lesson)),
  updateModuleLesson: (lessonId, data) =>
    dispatch(updateModuleLessonAction(lessonId, data)),
  deleteModuleLesson: lessonId => dispatch(deleteModuleLessonAction(lessonId))
});

export default connect(mapStateToProps, mapDispatchToProps)(ThematicPlan);
